import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, defaultBooleanField } from "helpers/row-logic-helper";

const DEFAULT_WIDTH = 138;

export const rows = {
  ratings: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Ratings",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "ratings"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  spShortDowngrade: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "S&P Short",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "spShortDowngrade.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  spLongDowngrade: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "S&P Long",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "spLongDowngrade.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  moodysShortDowngrade: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Moody’s Short",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "moodysShortDowngrade.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  moodysLongDowngrade: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Moody’s Long",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "moodysLongDowngrade.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  fitchShortDowngrade: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Fitch Short",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "fitchShortDowngrade.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  fitchLongDowngrade: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Fitch Long",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "fitchLongDowngrade.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  downgradeNotification: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Downgrade Notification",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.BOOLEAN,
        map: data => defaultBooleanField(data, "downgradeNotification"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
